import { FC } from "react"
import { AttentionsClone } from "../../../module/attentions/containers/clone"

export const AttentionsClonePage: FC = () => <AttentionsClone />
